export const SITE_LOG = "SITE_LOG";
export const RMTICKET_LOG = "RMTICKET_LOG";
export const COMPLAINT_LOG = "COMPLAINT_LOG";
